import {isNone, isWhite} from '~/data/accessors/color';

const TRANSPARENT_STRING = 'transparent';
const PURE_MAGENTA_STRING = 'FF00FF';

export function getClipartRecolorHexString(color) {
  if (isNone(color)) {
    return TRANSPARENT_STRING;
  }

  if (isWhite(color)) {
    return PURE_MAGENTA_STRING;
  }

  return color.hexString;
}
